
<div *ngIf="slide==0" class="flex flex-row-reverse">
  <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text" (click)="onClose()"></button>
</div>
<div [@animSlider]="slide" class="w-full h-full flex flex-row">
    <ng-container *ngIf="slide==0">

      <div class="flex-grow-1 p-6" >
        <form [formGroup]="form"  class="flex  flex-column gap-3" style="max-width:600px;" autocomplete="off"
          (ngSubmit)="onSubmit()"
        >
          <h1 class="mb-6">
            {{'DESC.EXERCISE_CREATE_TITLE' | translate}}
          </h1>
          <ng-container *ngIf="!isCreating; else elseTemplate">
            <div class="formgrid grid p-fluid form-content">
              <div class="field col-6">
                <label for="_period">{{'LABEL.EXERCISE_DATE' | translate}}</label>
                <p-calendar formControlName="period" view="month" dateFormat="mm/yy" inputId="monthpicker"
                  appendTo="body"
                  [placeholder]="'PLACEHOLDER.PROJECT_PERIOD_EX' | translate"
                  [ngClass]="{'ng-invalid ng-dirty' : isControlValid('period')}"
                ></p-calendar>
                <small *ngIf="isControlValid('period')" id="_period-help"
                  class="p-error block">{{getErrorMessage('period') | translate}}</small>
              </div>
            </div>

            <div>
              <button pButton pRipple  [label]="'BUTTON.CREATE_EXERCISE' | translate" class="p-button-primary "></button>
            </div>
          </ng-container>
          <ng-template #elseTemplate>
            <h5>{{'LABEL.CREATING_EXERCISE' | translate}}</h5>
            <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
          </ng-template>



        </form>
      </div>
      <div class="pt-6">
        <img src="/assets/images/save-planet.png" style="height:auto; width: calc(100vw / 3);">
      </div>
    </ng-container>

    <ng-container *ngIf="slide==1">
      <div  class="w-full flex justify-content-center">
        <div style="width: 500px;" class="flex flex-column align-content-center gap-3">
          <img src="/assets/images/save-planet.png" style="height:auto; width: 100%">
          <h3 class="text-center">
            {{'LABEL.EXERCISE_CREATED_SUCCESS' | translate}}
          </h3>
          <button pButton pRipple [label]="'BUTTON.CLOSE' | translate" class="p-button-primary" (click)="onClose(true)"></button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="slide==2">
      <div  class="w-full flex justify-content-center">
        <div style="width: 500px;" class="flex flex-column align-content-center justify-content-center gap-3">
          <img src="/assets/images/save-planet.png" style="height:auto; width: 100%">
          <h3 class="text-pink-600 text-center">
            {{'ERROR.EXERCISE_CREATE' | translate}}
          </h3>
          <button pButton pRipple [label]="'BUTTON.CLOSE' | translate" class="p-button-danger" (click)="onClose(false)"></button>
        </div>
      </div>
    </ng-container>

</div>
